<template>
  <div>
    <div>
      <button
        class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 m-2 rounded"
      >
        Cancel
      </button>
      <button
        v-on:click="saveNewSequence"
        class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 m-2 rounded"
      >
        Save
      </button>

      <button
        v-on:click="saveDeployNewSequence"
        class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 m-2 rounded"
      >
        Save and Deploy
      </button>
    </div>
    <div class="grid grid-cols-3">
      <div>
        <span class="mx-2">Fields</span>
        <DxSortable
          v-model:data="fieldList"
          :element-attr="sortableAttributes"
          :group="draggingGroupName"
          :allow-reordering="true"
          :allow-drop-inside-item="true"
          data="fieldList"
          @drag-start="onTabDragStart($event)"
          @reorder="onTabDrop($event)"
          @add="onTabDrop($event)"
        >
          <div
            v-for="tas in fieldList"
            :key="tas.dataField"
            class="card dx-card dx-theme-text-color dx-theme-background-color m-2"
          >
            <div v-if="checkVal(tas)" class="card-subject p-2">
              {{ tas.label.text }}
            </div>
            <div v-else class="card-subject p-2">{{ tas.label.text }}</div>
          </div>
        </DxSortable>
      </div>
      <div class="col-span-2">
        <span class="mx-2">Edit Layout</span>
        <div>
          <input type="text" v-model="grpName" />
          <button
            v-on:click="addNode"
            class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
          >
            add
          </button>
        </div>
        <DxSortable
          v-model:data="layoutDef"
          item-orientation="vertical"
          drag-direction="vertical"
          group="kk"
          :allow-reordering="true"
          data="layoutDef"
          @drag-start="onTabDragStart($event)"
          @reorder="onTabDrop($event)"
          @add="onTabDrop($event)"
          :allow-drop-inside-item="true"
        >
          <!-- <div v-for="tas in tags2" :key="tas.name" class="card dx-card dx-theme-text-color dx-theme-background-color m-2">
                        <div class="card-subject p-2">{{ tas.name }}</div>
                </div> -->
          <div
            v-for="task in layoutDef"
            :key="task.name"
            style="background: #86c285; margin: 5px"
            class="p-2"
          >
            <div class="list-title dx-theme-text-color">{{ task.name }}</div>
            <DxSortable
              v-model:data="task.items"
              data="task.items"
              :element-attr="sortableAttributes"
              :group="draggingGroupName"
              @drag-start="onTabDragStart($event)"
              @reorder="onTabDrop($event)"
              @add="onTabDrop($event)"
              :allow-reordering="true"
            >
              <div
                v-for="tas in task.items"
                :key="tas"
                class="card dx-card dx-theme-text-color dx-theme-background-color m-2"
              >
                <div v-if="checkVal(tas)" class="card-subject p-2">
                  {{ tas.label.text }}
                </div>
                <div v-else class="card-subject p-2">{{ tas.label.text }}</div>
              </div>
            </DxSortable>
          </div>
        </DxSortable>
      </div>
    </div>
  </div>
</template>

<script>
import DxSortable from "devextreme-vue/sortable";
import {
  getFieldsList,
  getLayout,
  setLayout,
  setDeployLayout,
} from "../../base.js";
export default {
  props: {
    modulekey: String,
    studio: Boolean,
    route_slug: String,
  },
  components: {
    DxSortable,
  },
  computed: {
    valueString() {
      let mod = JSON.stringify(this.layoutDef, null, 2);
      return mod;
    },
  },
  data() {
    return {
      grpName: "",
      draggingGroupName: "shared",
      sortableAttributes: {
        class: "classjj",
      },
      fieldList: [],
      layoutDef: [],

      items: [
        {
          dataField: "Address",
          editorType: "dxDateBox",
          editorOptions: {
            type: "datetime",
          },
        },
      ],
      field_List: new Object(),
    };
  },
  methods: {
    saveLayout() {
      console.log(this.layoutDef);
    },
    addNode() {
      let ab = {
        name: this.grpName,
        itemType: "group",
        items: [],
      };
      this.layoutDef.push(ab);
    },
    checkVal(val) {
      if (val instanceof Object) {
        return true;
      }
      return false;
    },
    onTabDragStart(e) {
      e.itemData = e.fromData[e.fromIndex];
    },
    onListReorder(e) {
      const list = this.tags.splice(e.fromIndex, 1)[0];
      this.tags.splice(e.toIndex, 0, list);
    },
    onTabDrop(e) {
      e.fromData.splice(e.fromIndex, 1);
      e.toData.splice(e.toIndex, 0, e.itemData);
    },
    saveNewSequence() {
      let model = JSON.stringify(this.layoutDef, null, 2);
      //post data
      this.errors = {};
      setLayout(this.modulekey, "detailview", this.studio, model,this.route_slug)
        .then((response) => {
          //console.log('get'+JSON.stringify(response.data));
        })
        .catch((error) => {
          if (error.response.status === 422) {
            this.errors = error.response.data.errors || {};
          }
        });
    },
    saveDeployNewSequence() {
      let model = JSON.stringify(this.layoutDef, null, 2);
      //post data
      this.errors = {};
      setDeployLayout(this.modulekey, "detailview", this.studio, model,this.route_slug)
        .then((response) => {
          //console.log('get'+JSON.stringify(response.data));
        })
        .catch((error) => {
          if (error.response.status === 422) {
            this.errors = error.response.data.errors || {};
          }
        });
    },
  },
  created: function () {
    //get field list of current module
    this.errors = {};
    getFieldsList(this.modulekey, this.studio, false,this.route_slug)
      .then((response) => {
        this.fieldList = Object.values(response.data);
        //this.defaultFieldList = Object.values(response.data);
        //console.log(response.data);
      })
      .catch((error) => {
        if (error.response.status === 422) {
          this.errors = error.response.data.errors || {};
        }
      });
    //get the editview layout
    getLayout(this.modulekey, "detailview", this.studio,this.route_slug)
      .then((response) => {
        //console.log(response.data);
        if (response.data != "") {
          this.layoutDef = response.data;
          this.fieldList = this.fieldList.filter(
            (item) =>
              !this.layoutDef.find((field) =>
                field.items.find(
                  (layoutItem) => item.dataField === layoutItem.dataField
                )
              )
          );
        }
      })
      .catch((error) => {
        //console.log("hh1");
        /* if (error.response.status === 422) {
            this.errors = error.response.data.errors || {};
            } */
      });
  },
  mounted() {},
};
</script>

<style>
.classjj {
  min-height: 20px;
  /* background: rgba(59, 130, 246, 0.5) */
  background: rgb(113, 181, 112);
  /* background: #17a2b8; */
}
</style>